import React, { useEffect, useState } from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function DashboardChoVay({totalLoanCredit, totalLoanInstallment}) {
//   const [totalLoanCredit, setTotalLoanCredit] = useState(0);
//   const [totalLoanInstallment, setTotalLoanInstallment] = useState(0);

// //   const fetchData = () => {
// //     const token = localStorage.getItem('token');

// //     fetch(`${process.env.REACT_APP_API_DB_URL}/data-dashboard`, {
// //       method: 'GET',
// //       headers: {
// //         'Authorization': `Bearer ${token}`,
// //         'Content-Type': 'application/json',
// //       },
// //     })
// //       .then(response => {
// //         if (!response.ok) {
// //           throw new Error(`HTTP error! Status: ${response.status}`);
// //         }
// //         return response.json();
// //       })
// //       .then(d => {
// //         setTotalLoanInstallment(d.totalLoanInstallment);
// //         setTotalLoanCredit(d.totalLoanCredit);
// //       })
// //       .catch(error => {
// //         console.error('Lỗi khi lấy dữ liệu:', error);
// //       });
// //   };

//   useEffect(() => {
//     fetchData();
//   }, []);

  // Cập nhật dữ liệu cho PieChart dựa trên dữ liệu từ API
  const chartData = [
    {
      value: totalLoanCredit,
      label: 'Tín Chấp',
      color: '#FF6B6B', // Màu đỏ cho Tín Chấp
    },
    {
      value: totalLoanInstallment,
      label: 'Trả Góp',
      color: '#20B2AA', // Màu xanh ngọc cho Trả Góp
    },
  ];

  const chartData2 = [
    {
      value: totalLoanCredit,
      label: '',
      color: '#FF6B6B', // Màu đỏ cho Tín Chấp
    },
    {
      value: totalLoanInstallment,
      label: '',
      color: '#20B2AA', // Màu xanh ngọc cho Trả Góp
    },
  ];

  return (
    <Stack direction="column" alignItems="center" spacing={2} sx={{ width: '100%' }}>
      {/* Tiêu đề ở phía trên */}
      <Typography variant="h6">
        Đang cho vay
      </Typography>

      {/* PieChart ở giữa và Legend ở bên phải */}
      <Stack direction="row" alignItems="center" spacing={1} sx={{ width: '100%', justifyContent: 'center' }}>
        <Stack alignItems="center" sx={{ position: 'relative' }}>
          <PieChart
            series={[
              {
                data: chartData2,
                innerRadius: 0.7, // Tạo hiệu ứng Donut Chart
              },
            ]}
            width={300}
            height={300}
          />
        </Stack>

        {/* Legend bên phải biểu đồ */}
        <Stack spacing={1} sx={{ ml: 4 }}>
          {chartData.map((item) => (
            <Stack direction="row" alignItems="center" spacing={1} key={item.label}>
              <Typography variant="body1">
                {item.label}: {item.value.toLocaleString('vi-VN')}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
}
